// extracted by mini-css-extract-plugin
export var burger = "burgerBtn-module--burger--1bqYY";
export var close = "burgerBtn-module--close--35y5S";